import { MatCheckboxChange } from '@angular/material/checkbox';
import { TranslationService } from '@sdbn/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor,NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-numberplate-input',
    templateUrl: './numberplate-input.component.html',
    styleUrls: ['./numberplate-input.component.scss'],
    providers: [
        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: NumberPlateInputComponent },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumberPlateInputComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class NumberPlateInputComponent implements ControlValueAccessor {

  numberPlate: string;

  inputEnabled = true;

  touched = false;

  disabled = false;

  @Input() formControlName: string;
  @Input() formGroup: FormGroup;

  @Input() labelCheckbox: string;
  @Input() labelInput: string;
  @Input() minLengthInput: string;


  onChange = (value) => {};

  onTouched = () => {};


  constructor(public translationService: TranslationService) {
  }

  setDescribedByIds(ids: string[]): void {
  }
  onContainerClick(event: MouseEvent): void {
  }

  writeValue(numberPlate: string): void {
    this.numberPlate = numberPlate;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  withoutFahrzeug(event: MatCheckboxChange): void {
    this.inputEnabled = !event.checked;
    if (this.inputEnabled) {
      this.formGroup.controls[this.formControlName].enable();
    } else {
      this.formGroup.controls[this.formControlName].disable();
    }
    this.markAsTouched();
  }


}
